const verifyAttributeExistenceToString = (object, attribute, addToEndLabel, defaultResult) => {
    let endResult = ''

    if (Array.isArray(attribute)) {
        for (let i = 0; i < attribute.length; i++) {
            if (object?.[attribute[i]]) {
                endResult += `${object[attribute[i]]}${i === attribute.length - 1 ? '' : ', '}`;
            }
        }
        if(endResult === '') return defaultResult;
        return endResult;
    } else {
        if (object?.[attribute]) {
            endResult = object[attribute];

            if (addToEndLabel) endResult = endResult + ' ' + addToEndLabel
        }
    }
    if(endResult === '') return defaultResult;
    return endResult;
}

export default verifyAttributeExistenceToString;
